import * as firebase from 'firebase/app'
import 'firebase/database'
import * as DB from '../../../database'

export default {
  namespaced: true,

  state: {
    localId: null,
    remoteId: null,
    roomId: null,
    messageHandlerRef: null,
    isReady: false,
    messages: []
  },

  mutations: {
    setEndPoints (state, { localId, remoteId }) {
      state.localId = localId
      state.remoteId = remoteId
    },

    setRoomId (state, { roomId }) {
      state.roomId = roomId
    },

    setMessageHandlerRef (state, { handlerRef }) {
      state.messageHandlerRef = handlerRef
    },

    setIsReady (state, { isReady }) {
      state.isReady = isReady
    },

    clearMessages (state) {
      global.DEBUG && console.log('clear messages')
      state.messages = []
    },

    addMessage (state, { messageId, userId, text }) {
      global.DEBUG && console.log(`add message: ${text}`)
      state.messages.push({ messageId, userId, text })
    }
  },

  actions: {
    start ({ commit, state }, { localId, remoteId, roomId }) {
      global.DEBUG && console.log('chat started')
      commit('setEndPoints', { localId: localId, remoteId: remoteId })
      commit('setRoomId', { roomId: roomId })
      let messageHandlerRef = firebase.database().ref(String.format(DB.CHAT_ROOM, state.roomId)).on('child_added', (data) => {
        commit('addMessage', { messageId: data.key, userId: data.val().userId, text: data.val().text })
      })
      commit('setMessageHandlerRef', { messageHandlerRef: messageHandlerRef })
      commit('setIsReady', { isReady: true })
    },

    async stop ({ state, commit }) {
      if (!state.isReady) {
        return
      }

      global.DEBUG && console.log('chat stopped')
      commit('setIsReady', { isReady: false })
      await firebase.database().ref(String.format(DB.CHAT_ROOM, state.roomId)).off('child_added', state.messageHandlerRef)
      commit('setMessageHandlerRef', { messageHandlerRef: null })
      commit('clearMessages')
    },

    async say ({ state }, { text }) {
      global.DEBUG && console.log(`sending message: ${text}`)
      let messageId = firebase.database().ref(String.format(DB.CHAT_ROOM, state.roomId)).push().key
      await firebase.database().ref(String.format(DB.CHAT_ROOM_MESSAGE, state.roomId, messageId)).set({
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        userId: state.localId,
        text: text
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/room/chat/index.js